import { RouterProvider } from 'react-router-dom';
import './App.css';
import './reset.css';
import { router } from './router';
import { useGlobalLang } from './global-context/global-lang';
import { useEffect } from 'react';

function App() {
  const [lang] = useGlobalLang();
  useEffect(() => {
    const htmlElement = document.querySelector('html');
    if (!htmlElement) return;
    htmlElement.setAttribute('lang', lang);
  }, [lang]);

  return <RouterProvider router={router} key={lang} />;
}

export default App;
